import axios from 'axios';
import Cookies from 'js-cookie'
import moment from "moment";

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use(
    function(config) {
        for(let param in config.params){
            if(config.params[param] instanceof Date){
                config.params[param] = moment(new Date(config.params[param])).format('YYYY-MM-DD HH:mm')
            }
        }
        const token = Cookies.get("token");
        if (token) {
            config.headers["Authorization"] = 'Bearer ' + token;
        }
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

api.interceptors.response.use((response)=>{
    return response;
},(error)=>{

    if(error.response){
        if(error.response.data.error === 'SESSION_NOT_FOUND' || error.response.data.error === 'SESSION_EXPIRED' || error.response.data.error ==='error_session_not_found'){
            
            const deleteUser = async() =>{
                /*if(Cookies.get('token') && Cookies.get('user')){
                    await api.delete(`${process.env.VUE_APP_API_URL}/auth/logout`)
                }*/
                Cookies.remove('user')
                Cookies.remove('token')
                if(window.location.pathname!=='/login'){
                    window.location.href = '/login'
                }
            }
            deleteUser()
        }
    }
    if(error.response.data.error){
        return Promise.reject(error.response.data.error);
    }
    else{
        return Promise.reject(error);
    }

})

export default api;
